import { NewsWidget, WidgetHost } from '@/core/widgets/export';
import { RouteObject } from 'react-router-dom';
import Assistant from '@/core/assistant/assistant';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleQuestion } from '@fortawesome/free-solid-svg-icons';

export class AssistantWidget implements NewsWidget {
  get defaultRoute(): string {
    return '/';
  }

  get defaultTitle(): string {
    return 'Whats happening?';
  }

  async hasPermission(permissions: string[]): Promise<boolean> {
    return permissions.includes('include-feature:alpha-access');
  }
  shouldHideToUser(permissions: string[]): boolean {
    return !permissions.includes('include-feature:alpha-access');
  }

  headerActions({ children }: { children?: React.ReactNode }): JSX.Element {
    return <>{children}</>;
  }

  get headerPanel(): JSX.Element {
    return (
      <>
        <FontAwesomeIcon icon={faCircleQuestion} /> Whats happening?
      </>
    );
  }

  get id(): string {
    return 'assistant';
  }

  initialize(host: WidgetHost): void {}

  get routes(): RouteObject[] {
    return [
      {
        path: '/',
        element: <Assistant />,
      },
    ];
  }

  get shortTitle(): JSX.Element {
    return (
      <>
        <FontAwesomeIcon icon={faCircleQuestion} /> Whats happening?
      </>
    );
  }
}
